import { useDispatch, useSelector } from 'react-redux';
import FJHistoryPanel from './FJHistoryPanel';
import useLocalStore from '../../../hooks/useLocalStore';
import FJActionModal from '../../../redux/action/FJActionModal';
import { useCallback } from 'react';
import FJActionCommon from '../../../redux/action/FJActionCommon';
import PropTypes from 'prop-types';
import FJSelectAll from '../../../common/components/FJSelectAll/FJSelectAll';
import FJAppConstant from '../../../constants/FJAppConstant';
import FJRequirementsUtil from '../../../util/FJRequirementsUtil.js';
import FJActionAIVideoGenerator from '../../../redux/action/FJActionAIVideoGenerator.js';
import { FJ_EVENT_TYPE } from '../../../constants/FJEvenTypeConstant.js';
import FJEvent from '../../../store/FJEvent.js';
import FJActionEditPage from '../../../redux/action/FJActionEditPage.js';
import FJUtil from '../../../util/FJUtil.js';

const FJHistoryPanelContainer = ({ activeHeaderTabIndex, headerChildren }) => {
    useLocalStore();
    const dispatch = useDispatch();

    const appType = useSelector(state => state.common.appType);
    const historyList = useSelector(state => state.common.historyList);
    const selectList = useSelector(state => state.common.selectList);
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);
    const historyListLoadStatus = useSelector(state => state.common.historyListLoadStatus);
    const batchDownloadLoading = useSelector(state => state.common.batchDownloadLoading);
    const sortType = useSelector(state => state.AIVideoGenerator.sortType);
    const isApplyButton = useSelector(state => state.common.isApplyButton);
    const addAsEditPageModalBtuStatus = useSelector(state => state.modals.addAsEditPageModalBtuStatus);

    let useHistoryList = [...historyList];
    if (appType === FJAppConstant.AI_VIDEO_GENERATOR) {
        useHistoryList = FJRequirementsUtil.getSortHistoryList(historyList, sortType);
    }
    const previewImage = data => {
        dispatch(FJActionModal.showPreviewModalDataAction({ data }));
        FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_SIDE_MODAL);
    };

    const setSliceSelectList = useCallback(
        value => {
            dispatch(FJActionCommon.setSelectListAction(value));
            FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_SIDE_MODAL);
        },
        [dispatch],
    );

    const multiDownload = useCallback(
        (ids, source, callback) => {
            dispatch(FJActionCommon.multiDownloadAction(ids, source, callback));
            FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_SIDE_MODAL);
        },
        [dispatch],
    );

    const multiDelete = useCallback(
        ids => {
            dispatch(FJActionCommon.multiDeleteAction(ids));
            FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_SIDE_MODAL);
        },
        [dispatch],
    );

    const onDelete = useCallback(
        id => {
            multiDelete([id]);
            FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_SIDE_MODAL);
        },
        [multiDelete],
    );

    const onDownload = useCallback(
        (id, callback) => {
            multiDownload([id], 'history', callback);
            FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_SIDE_MODAL);
        },
        [multiDownload],
    );
    const onEdit = useCallback(
        (item, callback) => {
            dispatch(FJActionCommon.editHistoryItemAction(item, callback));
            FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_SIDE_MODAL);
        },
        [dispatch],
    );

    const reGenerate = useCallback(
        id => {
            if (appType === FJAppConstant.AI_VIDEO_GENERATOR) {
                dispatch(FJActionAIVideoGenerator.retryTaskAction(id));
            }
        },
        [dispatch, appType],
    );
    const onReload = useCallback(
        id => {
            if (appType === FJAppConstant.AI_VIDEO_GENERATOR) {
                dispatch(FJActionAIVideoGenerator.regenerateCoverImageAction(id));
            }
        },
        [dispatch, appType],
    );
    const onAddToMedia = url => {
        dispatch(FJActionEditPage.addToMediaLibraryAction(url, { from: 'history' }));
    };

    const onAddToMediaLibrary = list => {
        dispatch(FJActionEditPage.addMultipleMediaToMediaLibraryAction(list, { from: 'history' }));
    };

    const onApplyMedia = (url, options) => {
        dispatch(FJActionEditPage.applyToEditPageAction(url, options));
    };

    const addAsEditPage = (idList, callback) => {
        dispatch(FJActionModal.addAsEditPageAction(idList, callback));
    };

    const addAsEditPageFromSelect = (idList, callback) => {
        const tool = FJUtil.getToolName();
        FJUtil.eaLog('ai tool multiple media to editor', {
            tool,
            number: idList.length,
        });
        addAsEditPage(idList, callback);
    };

    const isShowAddToMediaButton = window.isEditPage && appType !== FJAppConstant.FAKE_3D;
    const isShowAddToEditPageButton = !window.isEditPage && appType !== FJAppConstant.FAKE_3D;

    return (
        <>
            <FJHistoryPanel
                appType={appType}
                active={headerTabIndex === activeHeaderTabIndex}
                list={useHistoryList}
                selectList={selectList}
                historyListLoadStatus={historyListLoadStatus}
                setSliceSelectList={setSliceSelectList}
                onDownload={onDownload}
                onAddToMedia={onAddToMedia}
                onDelete={onDelete}
                previewImage={previewImage}
                onEdit={onEdit}
                headerChildren={headerChildren}
                reallyHistoryListLength={historyList.length}
                reGenerate={reGenerate}
                onApplyMedia={onApplyMedia}
                isApplyButton={isApplyButton}
                isShowAddToMediaButton={isShowAddToMediaButton}
                onAddToEditPage={(id, callback) => {
                    addAsEditPage([id], callback);
                }}
                isShowAddToEditPageButton={isShowAddToEditPageButton}
                onReload={onReload}
            />

            <FJSelectAll
                appType={appType}
                list={useHistoryList}
                selectList={selectList}
                setSelectList={setSliceSelectList}
                multiDownload={multiDownload}
                multiDelete={multiDelete}
                batchDownloadLoading={batchDownloadLoading}
                hideDownload={appType === FJAppConstant.FAKE_3D}
                onAddToMediaLibrary={onAddToMediaLibrary}
                onApply={onApplyMedia}
                addAsEditPage={addAsEditPageFromSelect}
                useApplyButton={isApplyButton}
                addAsEditPageModalBtuStatus={addAsEditPageModalBtuStatus}
                isShowAddToMediaButton={isShowAddToMediaButton}
                isShowAddToEditPageButton={isShowAddToEditPageButton}
            />
        </>
    );
};

FJHistoryPanelContainer.propTypes = {
    activeHeaderTabIndex: PropTypes.number,
    headerChildren: PropTypes.node,
};

export default FJHistoryPanelContainer;
